import { t } from "i18next"

export const MerchantType = [
  { label: t("All"), value: "" },
  { label: t("Ikata town"), value: "town" },
  { label: t("Hot spring"), value: "hotSpring" },
  { label: t("Sports center"), value: "sportsCenter" },
  { label: t("Loop bus"), value: "bus" },
]
